(function ($, w, undefined) {
    /**
     * @param {Function} clousure
     * @returns {boolean}
     */
    var isFunction = function (clousure) {
        return typeof clousure === 'function';
    };

    /**
     *
     * @param {Function} clousure
     * @param {String} status
     * @param {Object} response
     */
    var tryCallback = function (clousure, status, response) {
        if (isFunction(clousure)) {
            clousure.call(undefined, status, response);
        }
    };


    var FavoritesList = {
        init: function () {
            this.objects = $('.j-widget-favorites-remove, .j-widget-favorites-add');

            this.data = [];

            var self = this;

            this.objects.each(function () {
                self.initProduct(this);
            });

        },

        initProduct: function (selector) {
            var me = $(selector);

            if (me.attr('id') == undefined) {
                return;
            }
            var skin = me.data('skin') || 'default';
            var message = typeof me.data('message') !== 'undefined'
              ? me.data('message')
              : l10n('{A}Войдите на сайт{/A} чтобы {BR} добавить товар в избранное', {
                    '{A}' : '<a href="#" class="a-pseudo" onclick="Modal.open(\'#sign-in\'); return false;">',
                    '{/A}' : '</a>'
                });
            var product_id = me.attr('id').split('-')[1];

            var obj = {
                obj: me,
                html: me.siblings().addBack(), // TODO убрать этот странный костыль из-за которого кнопка "к сравнению"
                // TODO съебуется при добавлении товара в избранное на странице товара
                parent: me.parent(),
                product_id: product_id,
                skin: skin,
                buttonSize: me.data('button-size') || null,
                showButtonText: me.data('show-button-text') || null,
                message: message
            };
            this.data.push(obj);
            me.data('favoritesList', obj);

            var self = this;
            me.off('click.favorites').on('click.favorites', function () {
                if (me.is('.j-widget-favorites-remove')) {
                    self.removeProduct(product_id);
                } else if (me.is('.j-widget-favorites-add')) {
                    self.addProduct(product_id, null, me);
                } else {
                    return true;
                }

                return false;
            });
            self.trigger('onInit', me);
        },

        /**
         *
         * @param id
         * @param {Function} [callback]
         */
        removeProduct: function (id, callback) {
            if (this.trigger('onRemoveProduct', this.getProductsById(id), id) === false) {
                return;
            }
            var data = this.serializeProducts(),
                href = GLOBAL.URI_PREFIX + '_widget/favorites/remove/' + id + '/';


            var self = this;
            sendAjax(href, data, function (status, response) {
                if (status === 'OK') {
                    for (var i = response.products.length; --i >= 0; ) {
                        var pr = response.products[i];

                        self.replaceProduct(pr);
                    }
                    self.count = response.count * 1;
                    self.trigger('onAfterRemoveProduct', self.getProductsById(id), id);
                    self.trigger('onChange');
                } else if (status === 'UNAUTHORIZED') {
                    self.trigger('Unauthorized');
                }

                tryCallback(callback, status, response);
            });
        },

        /**
         *
         * @param id
         * @param {Function} [callback]
         * @param [caller]
         */
        addProduct: function (id, callback, caller) {
            if (this.trigger('onAddProduct', this.getProductsById(id), id) === false) {
                return;
            }
            var data = this.serializeProducts(),
                href = GLOBAL.URI_PREFIX + '_widget/favorites/add/' + id + '/';

            var self = this;
            sendAjax(href, data, function (status, response) {
                if (status === 'OK') {
                    for (var i = response.products.length; --i >= 0; ) {
                        var pr = response.products[i];
                        if (pr.id === Number(id)) {
                            var product = pr;
                        }

                        self.replaceProduct(pr);
                    }
                    self.count = response.count * 1;
                    self.trigger('onAfterAddProduct', self.getProductsById(id), id);
                    self.trigger('onChange');
                    triggerMarketingEvent('add_to_wishlist', [product, response.eventId]);
                } else if (status === 'UNAUTHORIZED') {
                    self.trigger('Unauthorized', id, caller);
                }
                tryCallback(callback, status, response);
            });
        },

        /**
         * @param {Function} [callback]
         */
        clear: function (callback) {
            if (this.trigger('onClear') === false) {
                return;
            }

            var href = GLOBAL.URI_PREFIX + '_widget/favorites/clear/';

            var self = this;
            sendAjax(href, {}, function (status, response) {
                if (status === 'OK') {
                    self.count = 0;
                    self.trigger('onAfterClear');
                    self.trigger('onChange');
                } else if (status === 'UNAUTHORIZED') {
                    self.trigger('onUnAuthorized');
                }
                tryCallback(callback, status, response);
            });
        },

        replaceProduct: function (productData) {
            var id = productData.id,
                skin = productData.skin,
                html = productData.html,
                buttonSize = productData.buttonSize,
                showButtonText = productData.showButtonText;
            var product = null,
                index = -1;
            for (var i = this.data.length; --i >= 0; ) {
                var pr = this.data[i];
                if (
                    pr.product_id == id &&
                    pr.skin == skin &&
                    pr.buttonSize == buttonSize &&
                    pr.showButtonText == showButtonText
                ) {
                    index = i;
                    product = pr;
                    break;
                }
            }

            if (product) {
                product.obj.removeAttr('id');
                var obj = $(html);
                obj.insertAfter(product.obj);
                product.obj.remove();

                this.data.splice(index, 1);

                this.initProduct(obj);
            }

        },

        getProductsById: function (product_id) {
            return $.grep(this.data, function (obj) {
                return obj.product_id == product_id;
            });
        },

        getProducts: function () {
            return this.data;
        },
        serializeProducts: function () {
            var data = [];
            $.each(this.data, function (i, obj) {
                if (obj.buttonSize !== null) {
                    data.push({name: 'products[' + i + '][buttonSize]', value: obj.buttonSize});
                }
                if (obj.showButtonText !== null) {
                    data.push({name: 'products[' + i + '][showButtonText]', value: obj.showButtonText});
                }
                data.push({name: 'products[' + i + '][skin]', value: obj.skin});
                data.push({name: 'products[' + i + '][id]', value: obj.product_id});
            });
            return data;
        }

    };
    $.extend(FavoritesList, TMEvents);
    $(function () {
        FavoritesList.init();
    });
    FavoritesList.count = 0;
    w.FavoritesList = FavoritesList;
})(jQuery, window);